import { CaretLeft, Rocket, BellSimpleRinging } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";


const ComingSoon = () => {
  const navigate = useNavigate();

  return (
    <main className="bg-gray-50 min-h-screen flex flex-col">
      {/* 1. We include your Dashboard Navbar here so the layout doesn't break */}
      
      <div className="flex-1 flex flex-col items-center justify-center p-6 text-center relative overflow-hidden">
        
        {/* Background Decorative Elements */}
        <div className="absolute top-1/4 left-1/4 w-72 h-72 bg-visaro-orange/5 rounded-full blur-3xl -z-10" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-deepBlue/5 rounded-full blur-3xl -z-10" />

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="max-w-xl w-full flex flex-col items-center gap-6"
        >
          {/* Illustration Icon */}
          <div className="bg-white p-6 rounded-3xl shadow-lg border border-gray-100 relative">
            <motion.div
              animate={{ rotate: [0, 10, -10, 0] }}
              transition={{ repeat: Infinity, duration: 4, ease: "easeInOut" }}
            >
              <Rocket size={64} weight="duotone" className="text-visaro-orange" />
            </motion.div>
            
            <motion.div 
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.5, type: "spring" }}
              className="absolute -top-2 -right-2 bg-deepBlue text-white p-2 rounded-full border-4 border-gray-50"
            >
              <BellSimpleRinging size={20} weight="fill" />
            </motion.div>
          </div>

          {/* Text Content */}
          <div className="flex flex-col gap-3">
            <h1 className="text-3xl md:text-5xl font-bold text-deepBlue">
              Marketplace is <br />
              <span className="text-visaro-orange">Coming Soon</span>
            </h1>
            <p className="text-gray-500 text-lg md:text-xl leading-relaxed">
              We are building a secure way for you to shop and pay directly from your Visaro account. Stay tuned!
            </p>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto mt-4">
            <button
              onClick={() => navigate(-1)}
              className="px-8 py-3 rounded-xl border-2 border-gray-300 text-gray-600 font-bold hover:bg-gray-100 transition-all flex items-center justify-center gap-2"
            >
              <CaretLeft weight="bold" /> Go Back
            </button>
            
            <button
              onClick={() => navigate("/")} // Redirect to dashboard/home
              className="px-8 py-3 rounded-xl bg-deepBlue text-white font-bold hover:bg-deepBlue/90 shadow-lg shadow-deepBlue/20 transition-all"
            >
              Go to Dashboard
            </button>
          </div>
        </motion.div>
      </div>
    </main>
  );
};

export default ComingSoon;